<template>
  <div class="container">
    <van-image
      class="bg"
      :src="'zq_pro/zyx_holidays/521_bg.png'|imgUrlFormat"
      fit="contain"
    />
    <div class="main">
      <div class="tab-content">
        <div class="form-item">
          <input
            class="input"
            placeholder-class="placeholderClass"
            name="input"
            placeholder="请输入手机号码"
            v-model="phone"
            @blur="blur"
          />
        </div>
        <div class="form-item message">
          <input
            class="input"
            placeholder-class="placeholderClass"
            name="input"
            placeholder="请输入验证码"
            v-model="code"
            @blur="blur"
          />
          <div class="button" @click="sendMsg('FREE_CARD_VERIFY')">{{ msgSendTxt }}</div>
        </div>
        <div class="btn-v">
          <button class="button" @click="loveBindCard">立 即 领 取</button>
        </div>
        <div class="desc">
          <span>*激活成功后，请使用该激活手机号登录微信 小程序“中青自由行”，可立即使用</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5"
import Cookies from "js-cookie"
import { checkUserAgent } from '@/utils/checkUserAgent'
import { commonSendSms } from '@/api/index.js'
import { loveBindCard } from '@/api/holidays'
import { Toast, Dialog } from "vant"


export default {
  name: "CardActive",
  components: {},
  mixins: [checkUserAgent],
  data() {
    return {
      phone: "",
      code: "",
      msgSendStatus: true,
      msgSendTxt: "获取验证码",
      channelId: "",
      productId: "",
      userAgent: '',
      number: 1,
      mode: 1,
      activateFlag: ''
    }
  },
  created() {},
  computed: {},
  methods: {
    blur() {
      document.querySelector('body').setAttribute('style', 'height:'+document.documentElement.clientHeight+'px;')
      window.scrollTo(0,0)
    },
    // 发送短信
    sendMsg(tag) {
      const that = this;
      if (this.phone.length < 1) {
        this.$toast("手机号为空");
        return false;
      } else {
        const reg = /^1[3-9]\d{9}$/g;
        const result = reg.test(this.phone);
        if (!result) {
          this.$toast("请输入正确格式的手机号");
          return;
        }
      }
      if (!this.msgSendStatus) {
        return;
      }
      const appId = 1;
      const key = 1112;
      const sortstr = "appId=" + appId + "&phone=" + this.phone + "" + key;

      const sign = md5(sortstr).toUpperCase();

      const data = {
        sign: sign,
        appId: appId,
        phone: this.phone,
        productType: Cookies.get("productType")||0,
        tag
      };
      commonSendSms(data).then(res=>{
        console.log(res)
        if (res.data.code !== 200) {
            throw res.data.msg;
          }
          if (res.data.code === 200) {
            that.$toast(res.data.msg);
            let time = 60;
            (that.msgSendStatus = false), (that.msgSendTxt = time + "秒再试");
            let timer = setInterval(function () {
              if (time <= 0) {
                (that.msgSendStatus = true), (that.msgSendTxt = "获取验证码");
                clearInterval(timer);
                return false;
              }
              that.msgSendTxt = time + "秒再试";
              that.sendStatus = false;
              time--;
            }, 1000);
          }
      }).catch((err) => {
        that.$toast(err);
      });
    },
    // 在线激活
    loveBindCard() {
      let that = this
      if (this.phone.length < 1) {
        return this.$toast("手机号为空");
      } else {
        const reg = /^1[3-9]\d{9}$/g;
        const result = reg.test(this.phone);
        if (!result) { return this.$toast("请输入正确格式的手机号"); }
      }
      if (this.code.length < 1) { return this.$toast("验证码为空"); }
      let data = {
        phone: this.phone,
        tag: 'FREE_CARD_VERIFY',
        code: this.code
      }
      console.log(data)
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      loveBindCard(data).then(res=>{
        Toast.clear();
        if (res.data.code !== 200) {
            throw res.data.msg;
          }
          if (res.data.code === 200) {
            Dialog.confirm({
              title: "",
              message: "您的会员卡已成功激活，请前往小程序使用",
              showCancelButton: true,
              confirmButtonText: "现在前往",
              confirmButtonColor: "#00C5A5",
              cancelButtonText: "我知道了",
              cancelButtonColor: "#848484"
            })
              .then(() => {
                location.href = 'weixin://dl/business/?t=5o4T2fN28Sa'
              })
              .catch(() => {})
            
          }
      }).catch((err) => {
        Toast.clear();
        that.$toast(err);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
html,
body,
#app {
  margin: 0;
}
.container {
  position: relative;
  height: 100vh;
  background: #FADBDF;
  .bg {
    width: 750px;
    height: 1334px;
  }
  .main {
    position: absolute;
    top: 520px;
    left: 50%;
    z-index: 100;
    box-sizing: border-box;
    margin-left: -280px;
    border: 3px dashed #FCDFE4;
    padding: 60px 30px;
    width: 560px;
  }
}
.tab-content .form-item {
  margin-bottom: 40px;
  font-size: 32px;
}
.tab-content .form-item.message {
  display: flex;
  justify-content: space-between;
}
.tab-content .form-item .input {
  border-radius: 40px;
  padding: 0 40px;
  width: calc(100% - 80px);
  height: 70px;
  background: #EFECEC;
}
.tab-content .form-item.message .input {
  width: calc(100% - 230px);
}
.tab-content .form-item .placeholderClass {
  font-size: 20px;
  line-height: 70px;
  color: #EFECEC;
}
.tab-content .form-item.message .button {
  width: 180px;
  height: 70px;
  font-size: 28px;
  line-height: 70px;
  text-align: center;
  color: #E76060;
}

.tab-content .btn-v .button {
  margin-top: 40px;
  border-radius: 40px;
  width: 100%;
  height: 70px;
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  background: #E76060;
}
.tab-content .splitLine{
  width: 600px;
  height: 0px;
  border: 2px solid #EEEEEE;
  margin: 32px auto 34px auto;
}
.tab-content .quantitySelection{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
}
.tab-content .quantitySelection .selectQuant{
  height: 44px;
  font-size: 32px;
  font-weight: bold;
  color: #333333;
  line-height: 44px;
  margin-right: 14px;
}
.tab-content .quantitySelection .quant{
  width: 80px;
  height: 56px;
  background: #F6F6F6;
  border-radius: 28px;
  text-align: center;
  font-size: 32px;
  color: #666666;
  line-height: 56px;
  margin-left: 8px;
}
.tab-content .quantitySelection .quant.active{
  color: #FFFFFF;
  background: #00C5A5;
}
.tab-content .desc {
  width: 470px;
  margin: 16px auto 0 auto;
  font-size: 12px;
  color: #8D8D8D;
  line-height: 34px;
  text-align: center;
}
</style>
